import { render, staticRenderFns } from "./CreateOrderModel.vue?vue&type=template&id=f7b0112c&"
import script from "./CreateOrderModel.vue?vue&type=script&lang=js&"
export * from "./CreateOrderModel.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports